// Phase G3 Stage 1b: /play/math-coach — alias of /play/coach.
// Storybook ships both paths; we mirror the dual-route for direct-
// copy fidelity when ports reference either URL.
import { createFileRoute } from "@tanstack/react-router";
import { CoachHint } from "@/screens/CoachHint";

export const Route = createFileRoute("/play/math-coach")({
  component: CoachHint,
});
